import { CART_MODULE } from "@/api_framework/api_config";
import { ICartSearchResponse, ICartSearchResponseData } from "@/api_framework/api_modals/Cart";
import { useConfiguration } from "@/app/hooks/useConfiguration";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import axios, { AxiosError, AxiosResponse } from "axios";
import AxiosCurlirize from "axios-curlirize";
import { useCallback, useState } from "react";
import { useAPIUtils } from "../../useAPIUtils";
import { setLoading } from "@/app_redux/reducers/loading_reducer";

AxiosCurlirize(axios, () => {});
type ICartAPIResponse = { status: boolean; message: any };

export const useCartSearchAPI = () => {
  const configuration = useConfiguration();
  const [data, setData] = useState<ICartSearchResponseData[]>([]);
  const dispatch = useAppDispatch();
  const { captureError } = useAPIUtils();
  const { sendCurl } = useCurlLogger();

  const clearSearchResults = () => {
    setData([]);
  };

  const execute = useCallback(
    async (query: string, clinicId: string, petId: string, search_tag?: string | string[], pincode?: string, cat_id?: string) => {
      dispatch(
        setLoading({
          key: "isCustomerCartItemsSearchInProgress",
          status: true,
        }),
      );
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
        const response: ICartAPIResponse = await axios
          .get(`${CART_MODULE?.CART_SEARCH?.baseURL}`, {
            params: {
              pet_id: petId,
              clinic_id: clinicId,
              search_keyword: query,
              search_tag: search_tag,
              pincode: pincode,
              cart_id: cat_id,
              source: "vms_cart",
            },
            paramsSerializer: {
              indexes: null,
            },
            headers: {
              Authorization: `${accessToken}`,
              "Content-Type": "application/json",
            },
          })
          .then((res: AxiosResponse<ICartSearchResponse>) => {
            if (res.data.status === true) {
              setData(res.data.data);
              dispatch(
                setLoading({
                  key: "isCustomerCartItemsSearchInProgress",
                  status: false,
                }),
              );
              return { status: true, message: res.data.data };
            } else {
              setData([]);
              dispatch(
                setLoading({
                  key: "isCustomerCartItemsSearchInProgress",
                  status: false,
                }),
              );
              return { status: false, message: "cart_not_filtered" };
            }
          })
          .catch((e: AxiosError) => {
            sendCurl(e.config["curlCommand"]);
            captureError(e);
            dispatch(
              setLoading({
                key: "isCustomerCartItemsSearchInProgress",
                status: false,
              }),
            );
            return { status: false, message: "cart_not_filtered" };
          });
        return response;
      } catch (e: any) {
        dispatch(
          setLoading({
            key: "isCustomerCartItemsSearchInProgress",
            status: false,
          }),
        );
        captureError(e);
      }
    },
    [dispatch],
  );
  return { data, execute, clearSearchResults };
};
